import {Component, input, output} from '@angular/core';
import {ContentBlock} from '../../../../../shared/models/configuration.model';
import {MatRadioButton} from '@angular/material/radio';
import {MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';

@Component({
  selector: 'app-content-block',
  templateUrl: './content-block.component.html',
  imports: [
    MatRadioButton,
    MatIconButton,
    MatIcon,
    MatIconButton,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger
  ]
})
export class ContentBlockComponent {

  contentBlock = input<ContentBlock>();

  contentBlockDeleted = output<void>();
  contentBlockSelected = output<void>();
  contentBlockUpdated = output<void>();

  constructor() { }


}
